import { useTranslation } from 'react-i18next'

import { PlusIcon, SparkleIcon } from '@phosphor-icons/react'

import { ButtonWithSpinner, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnMethodsSuggestionBanner = ({ onCreate, creating }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Styles.Content>
        <Styles.LabelContainer>
          <SparkleIcon size={24} />
          <Text type="titleXS">{t('SUGERENCIA')}</Text>
        </Styles.LabelContainer>
        <Text type="bodyMRegular">
          {t(
            'Aún no tienes ningún Return Method creado. ¿Quieres que creemos unos por defecto asociados a esta ubicación?'
          )}
        </Text>
      </Styles.Content>
      <ButtonWithSpinner
        variant="outlined"
        loading={creating}
        disabled={creating}
        defaultLabel={
          <>
            <PlusIcon size={24} />
            {t('Crear métodos de devolución')}
          </>
        }
        loadingLabel={t('Crear métodos de devolución')}
        onClick={onCreate}
      />
    </Styles.Container>
  )
}

export default ReturnMethodsSuggestionBanner
